import LoadingFailure from '../components/LoadingFailure';
import { retryLoad } from '../components/retryLoad';
import LoadingScreen from '../components/LoadingScreen';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { checkMasterSession } from './masterSession';
import { MASTER_INVALID_EVENT, MASTER_UNAVAILABLE_EVENT } from '../components/sessionTransport';

export default function MasterProtectedRoute() {
  const location = useLocation();
  const [status, setStatus] = useState('checking');
  const [outage, setOutage] = useState(false);
  useEffect(() => {
    const invalid = () => setStatus('unauthenticated');
    const unavailable = () => setOutage(true);
    window.addEventListener(MASTER_INVALID_EVENT, invalid);
    window.addEventListener(MASTER_UNAVAILABLE_EVENT, unavailable);
    return () => {
      window.removeEventListener(MASTER_INVALID_EVENT, invalid);
      window.removeEventListener(MASTER_UNAVAILABLE_EVENT, unavailable);
    };
  }, []);
  useEffect(() => {
    let active = true;
    retryLoad(async () => { const result = await checkMasterSession(); if (result === "unavailable") throw new Error("Session unavailable"); return result; }).catch(() => "unavailable").then(result => {
      if (!active) return;
      setOutage(result === 'unavailable');
      setStatus(previous => previous === 'authenticated' && result === 'unavailable' ? previous : result);
    });
    return () => { active = false; };
  }, []);

  const recovery = <LoadingFailure compact={status === "authenticated"} />;
  if (status === 'checking') return <LoadingScreen label="Checking session…" fullScreen />;
  if (status === 'unavailable') return recovery;
  if (status === 'unauthenticated') return <Navigate to="/master/login" state={{ from: location.pathname }} replace />;
  return <>{outage && recovery}<Outlet /></>;
}

